
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {getCurrentSite} from 'redux/modules/currentUser/selectors'
import {editCountryLimitList} from 'redux/modules/sites/actions'
import AddRegionForm from './AddRegionForm'
import EditRegionForm from './EditRegionForm'

export class SettingsRegionView extends React.Component {
  static propTypes = {
    currentSite: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    editCountryLimitList: PropTypes.func
  }

  render() {
    const {currentSite, editCountryLimitList} = this.props
    const countriesLimit = currentSite.countriesLimit
      ? [...currentSite.countriesLimit]
      : []
    const countriesData = currentSite.countriesData
      ? [...currentSite.countriesData]
      : []
    return (
      <div className='settings-region-view container'>
        <div className='settings-region-view_container'>
          <div className='settings-region-view_intro'>
            In this section you can select the specific countries that will be displayed across all reports.
          </div>
          <AddRegionForm
            siteId={currentSite.id}
            countriesLimit={countriesLimit}
            countriesData={countriesData}
          />
          <EditRegionForm
            countriesLimit={countriesLimit}
            countriesData={countriesData}
            onRemoveContries={countries => {
              const data = countriesLimit?.filter(el => {
                return countries.indexOf(el) < 0
              })

              editCountryLimitList({
                id: currentSite.id,
                countriesLimit: data
              })
            }}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  currentSite: getCurrentSite(state)
})

export default connect(mapStateToProps, {editCountryLimitList})(SettingsRegionView)



// WEBPACK FOOTER //
// ./client/views/SettingsRegionView/index.js